import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type EditsSlice = {
    name: string,
    email: string,
    word: string
};

const initialState: EditsSlice = {
    name: '',
    email: '',
    word: ''
};

const editsSlice = createSlice({
    name: 'edits',
    initialState,
    reducers: {
        inputEmail_edits: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        inputName_edits: (state, action: PayloadAction<string>) => {
            state.name = action.payload;
        },
        inputWord_edits: (state, action: PayloadAction<string>) => {
            state.word = action.payload;
        },
        reset_edits: (state, action: PayloadAction<'email' | 'word'>) => {
            const { payload } = action;
            if (payload === 'email') {
                state.name = initialState.name;
                state.email = initialState.email;
            } else {
                state.word = initialState.word;
            }
        }
    }
});

export const {
    inputName_edits,
    inputEmail_edits,
    inputWord_edits,
    reset_edits
} = editsSlice.actions;

export default editsSlice.reducer;